<svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 1.5L7 12.5L2 7.5" stroke="#51A461" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>